import logoImage from '@/assets/xrepl-logo.png';

interface LogoProps {
  size?: 'sm' | 'md' | 'lg' | 'xl';
  className?: string;
  variant?: 'light' | 'mute';
}

export function Logo({ size = 'md', className = '', variant = 'light' }: LogoProps) {
  const sizes = {
    sm: 'w-8 h-8',
    md: 'w-10 h-10',
    lg: 'w-16 h-16',
    xl: 'w-32 h-32'
  };

  return (
    <div className={`${sizes[size]} ${className} relative`}>
      <img 
        src={logoImage}
        alt="xRepl.ai" 
        className={`w-full h-full object-contain ${variant === 'mute' ? 'opacity-60 grayscale' : ''}`}
      />
    </div>
  );
}
